import { ClubsFormComponent } from './clubs-form/clubs-form.component';
import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { ClubsComponent } from './clubs.component';
import { ClubsRoutingModule } from './clubs-routing.module';
import { ClubsDetailComponent } from './clubs-detail/clubs-detail.component';

@NgModule({
  declarations: [ClubsComponent, ClubsFormComponent, ClubsDetailComponent],
  imports: [
    SharedModule,
    ClubsRoutingModule
  ]
})
export class ClubsModule { }
